import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../Theme';

/**
 * Import Themes
 */

import cardCommonTheme from './common';

import cardBlogTheme from './_blog';
import cardSiteTheme from './_site';

/**
 * Group Themes
 */

const cardThemes = new MatchedMap([
  [ThemeEnum.Blog, cardBlogTheme],
  [ThemeEnum.Site, cardSiteTheme],
]);

/**
 * Theme Hook
 */

const useCardTheme = () => useTheme(cardCommonTheme, cardThemes);

export default useCardTheme;
